import { render } from "./VehicleRegistrationPlates.vue?vue&type=template&id=35b7a434"
import script from "./VehicleRegistrationPlates.vue?vue&type=script&lang=js"
export * from "./VehicleRegistrationPlates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__